import React, { useEffect, useState } from "react";
import {useTranslation} from "react-i18next";
import { Card, Form } from "react-bootstrap";
import { InstitutionApiCalls } from "../../../../apis/InstitutionApiCalls";
import generalIcon from "../../../../images/generalIcon.svg";
import roleMapping from "../../../../images/roleMapping.svg";
import userProvisioning from "../../../../images/userProvisioning.svg";
import crossIntegrationLTI from "../../../../images/crossIntegrationLTI.svg";
import {
    INTEGRATION_TYPES,
    ROLES
} from "../../../../utils/constants";
import styles from "./SAML.module.css";
import {YuJaTextBox} from "../../../../components/standardization/YuJaTextBox";
import { YuJaCheckbox } from "../../../../components/standardization/YuJaCheckbox";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {YuJaToggle} from "../../../../components/standardization/YuJaToggle";

export default function GeneralGoogleTab({setConfigJson, handleSave, ssoURL, setSSOURL, nameIdFormat, setNameIdFormat, remoteLogoutUrl, setRemoteLogouUrl, 
    certificateFingerPrint, setCertificateFingerPrint, logoutUrl, setLogoutUrl, setSignatureEnabled, givenNameAttribute, 
    setGiveNameAttribute, familyNameAttribute, setFamilyNameAttribute, emailAttribute, setEmailAttribute, roleAttribute, 
    setRoleAttribute, itManagerMapping,  setITManagerMapping, instructorMapping, setInstructorMapping, linkageAttribute, setLinkageAttribute, fallbackToEmail, setFallbackToEmail}) {
    const {t} = useTranslation();

    const {getSSODetails} = InstitutionApiCalls();
    const [loading , setLoading] = useState(false); 

    const fetchData = () => {
        setLoading(true);
        getSSODetails().then((result) => {
            let ssoMap = result.ssoConfig;
            const ssoConfigData = JSON.parse(ssoMap.hasOwnProperty(INTEGRATION_TYPES.GOOGLE) ? ssoMap.GOOGLE : "{}");
            if(ssoConfigData !== 'undefined' || ssoConfigData.propertyIsEnumerable()) {
                setSSOURL(ssoConfigData.samlSsoUrl);
                setNameIdFormat(ssoConfigData.nameIdFormat);
                setRemoteLogouUrl(ssoConfigData.remoteLogoutUrl);
                setCertificateFingerPrint(ssoConfigData.certificateFingerPrint);
                setLogoutUrl(ssoConfigData.logoutUrl);
                setSignatureEnabled(ssoConfigData.signatureEnabled);
                setGiveNameAttribute(ssoConfigData.givenNameAttribute);
                setFamilyNameAttribute(ssoConfigData.familyNameAttribute);
                setEmailAttribute(ssoConfigData.emailAttribute);
                setRoleAttribute(ssoConfigData.roleAttribute);
                setITManagerMapping(ssoConfigData.itManagerMapping);
                setInstructorMapping(ssoConfigData.instructorMapping);
                setLinkageAttribute(ssoConfigData.linkageAttribute);
                setFallbackToEmail(ssoConfigData.fallbackToEmail);
                setConfigJson(ssoConfigData);
            }
            setLoading(false);
        })
        // setLoading(false);
    }

    useEffect(() => {
        fetchData();
        if(document.getElementById("ssoLastElem") != null) {
            document.getElementById("ssoLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("integrationSaveBtn")) {
                  e.preventDefault();
                  document.getElementById('integrationSaveBtn').focus();
                }
            });
        }
    },[]);

    const handleSSOURLChange = (e) => {
        e.preventDefault();
        setSSOURL(e.target.value);
    };

    const handleNameIDChange = (e) => {
        e.preventDefault();
        setNameIdFormat(e.target.value);
    };

    const handleRemoteLogoutChange = (e) => {
        e.preventDefault();
        setRemoteLogouUrl(e.target.value);
    }

    const handleFingerPrintChange = (e) => {
        e.preventDefault();
        setCertificateFingerPrint(e.target.value);
    }

    const handleLogoutChange = (e) => {
        e.preventDefault();
        setLogoutUrl(e.target.value);
    }

    const handleAuthReqSignChange = (e) => {
        e.preventDefault();
        setSignatureEnabled(e.target.checked);
    }

    const handleGivenNameChange = (e) => {
        e.preventDefault();
        setGiveNameAttribute(e.target.value);
    }

    const handleFamilyNameChange = (e) => {
        e.preventDefault();
        setFamilyNameAttribute(e.target.value);
    }

    const handleEmailChange = (e) => {
        e.preventDefault();
        setEmailAttribute(e.target.value);
    }

    const handleRoleChange = (e) => {
        e.preventDefault();
        setRoleAttribute(e.target.value);
    }

    const handleITManagerMappingChange = (e) => {
        e.preventDefault();
        setITManagerMapping(e.target.value);
    }

    const handleInstructorMappingChange = (e) => {
        e.preventDefault();
        setInstructorMapping(e.target.value);
    }

    const handleLinkageAttributeChange = (e) => {
        e.preventDefault();
        setLinkageAttribute(e.target.value);
    }

    const handleFallbackToEmailChange = (e) => {
        e.preventDefault();
        const input = e.currentTarget;
        setFallbackToEmail(input.checked);
    }

    return (
        <div style={{display: "flex", flexDirection: "row", gap: 20, flexWrap: "wrap", marginTop: 20}}>
            <Card className={styles.smallBox}>
                <Card.Header>
                <img src={generalIcon} alt="GeneralSSODetails" width={"24px"} height={"24px"} />
                <span className={styles.cardHeader}>{t("integration.generalSsoDetails")}</span>
                </Card.Header>
                <Card.Body>
                    <Form>
                    {!loading &&
                        <>
                        <Form.Group controlId="ssoURL">
                            <div className="form-label" style={{marginTop: 0}}>{t("integration.googleSsoUrl")}*</div>
                            <YuJaTextBox
                                name="ssoURL"
                                placeholder={t("integration.googleSsoUrl")}
                                value={ssoURL}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleSSOURLChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="nameIdFormat">
                            <div className="form-label">{t("integration.nameIdFormat")}*</div>
                            <YuJaTextBox
                                name="nameIdFormat"
                                placeholder={t("integration.nameIdFormat")}
                                value={nameIdFormat}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleNameIDChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="remoteLogoutUrl">
                            <div className="form-label">{t("integration.remoteLogoutUrl")}</div>
                            <YuJaTextBox
                                name="remoteLogoutUrl"
                                value={remoteLogoutUrl}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleRemoteLogoutChange}
                                placeholder={t("integration.remoteLogoutUrl")}
                            />
                        </Form.Group>

                        <Form.Group controlId="certificateFingerPrint">
                            <div className="form-label">{t("integration.googleCertificate")}</div>
                            <YuJaTextBox
                                name="certificateFingerPrint"
                                value={certificateFingerPrint}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange= {handleFingerPrintChange}
                                placeholder={t("integration.googleCertificate")}
                            />
                        </Form.Group>

                        <Form.Group controlId="logoutUrl">
                            <div className="form-label">{t("integration.logoutUrl")}</div>
                            <YuJaTextBox
                                name="logoutUrl"
                                value={logoutUrl}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleLogoutChange}
                                placeholder={t("integration.logoutUrl")}
                            />
                        </Form.Group>
                        </>
                    }
                        {
                        loading &&  <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                        <div style={{display: "flex", flexDirection: "column"}}>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        </div>
                        </SkeletonTheme>
                    }
                    </Form>
                </Card.Body>
            </Card>
            <Card className={styles.smallBox}>
                <Card.Header>
                    <img src={userProvisioning} alt="UserProvisioning" width={"24px"} height={"24px"} />
                    <span className={styles.cardHeader}>{t("integration.userProvisioning")}</span>
                </Card.Header>
                <Card.Body>
                    <Form>
                    {!loading &&
                        <>
                        <Form.Group controlId="givenNameAttribute">
                            <div className="form-label" style={{marginTop: 0}}>{t("integration.givenNameAttribute")}</div>
                            <YuJaTextBox
                                name="givenNameAttribute"
                                value={givenNameAttribute}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleGivenNameChange}
                                placeholder={t("integration.givenNameAttribute")}
                            />
                        </Form.Group>

                        <Form.Group controlId="familyNameAttribute">
                            <div className="form-label">{t("integration.familyNameAttribute")}</div>
                            <YuJaTextBox
                                name="familyNameAttribute"
                                value={familyNameAttribute}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleFamilyNameChange}
                                placeholder={t("integration.familyNameAttribute")}
                            />
                        </Form.Group>

                        <Form.Group controlId="emailAttribute">
                            <div className="form-label">{t("integration.emailAttribute")}</div>
                            <YuJaTextBox
                                name="emailAttribute"
                                value={emailAttribute}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleEmailChange}
                                placeholder={t("integration.emailAttribute")}
                            />
                        </Form.Group>

                        <Form.Group controlId="roleAttribute">
                            <div className="form-label">{t("integration.roleAttribute")}</div>
                            <YuJaTextBox
                                name="roleAttribute"
                                value={roleAttribute}
                                style={{fontSize: 14, lineHeight: 1.6,}}
                                onChange={handleRoleChange}
                                placeholder={t("integration.roleAttribute")}
                            />
                        </Form.Group>
                        </>
                    }
                        {
                        loading &&  <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                        <div style={{display: "flex", flexDirection: "column"}}>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        </div>
                        </SkeletonTheme>
                    }
                    </Form>
                </Card.Body>
            </Card>
            <div style={{display: "flex", flex: 1, flexWrap: "wrap", minWidth: 400, gap: 20, height: "fit-content"}}>
                <Card className={styles.smallBox}>
                    <Card.Header>
                        <img src={roleMapping} alt="RoleMapping" width={"24px"} height={"24px"} />
                        <span className={styles.cardHeader}>{t("integration.roleMapping")}</span>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                        {!loading &&
                        <>
                            <Form.Group controlId="itManagerMapping">
                                <div className="form-label" style={{marginTop: 0}}>{t(ROLES.IT_MANAGER.labelKey)}</div>
                                <YuJaTextBox
                                    name="itManagerMapping"
                                    value={itManagerMapping}
                                    style={{fontSize: 14, lineHeight: 1.6,}}
                                    onChange={handleITManagerMappingChange}
                                    placeholder={t("integration.itManagerMapping")}
                                />
                            </Form.Group>

                            <Form.Group controlId="instructorMapping">
                                <div className="form-label">{t("integration.instructorLabel")}</div>
                                <YuJaTextBox
                                    name="instructorMapping"
                                    value={instructorMapping}
                                    style={{fontSize: 14, lineHeight: 1.6,}}
                                    onChange={handleInstructorMappingChange}
                                    placeholder={t("integration.instructorMapping")}
                                />
                            </Form.Group>
                            </>
                    }
                        {
                        loading &&  <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                        <div style={{display: "flex", flexDirection: "column"}}>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        </div>
                        </SkeletonTheme>
                    }
                        </Form>
                    </Card.Body>
                </Card>
                <Card className={styles.smallBox}>
                    <Card.Header>
                        <img src={crossIntegrationLTI} alt="CrossIntegrationLTI" width={"24px"} height={"24px"} />
                        <span className={styles.cardHeader}>{t("integration.crossIntegrationWithLti")}</span>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                        {!loading &&
                        <>
                            <Form.Group controlId="linkageAtrributeGrp">
                                <div className="form-label" style={{marginTop: 0}}>{t("integration.linkageAttribute")}</div>
                                <YuJaTextBox
                                    name="linkageAttribute"
                                    value={linkageAttribute}
                                    style={{fontSize: 14, lineHeight: 1.6,}}
                                    onChange={handleLinkageAttributeChange}
                                    placeholder={t("integration.linkageAttribute")}
                                />
                            </Form.Group>
                            <Form.Group controlId="fallbackToEmail" className={styles.toggleRow} style={{marginTop: 15}}>
                                <div className={styles.toggleTextRow}>
                                    <div>{t("integration.fallBackToEmailSaml")}</div>
                                    <div className={styles.toggleDescriptionText}>{t("integration.fallBackToEmailSamlDesc")}</div>
                                </div>
                                <YuJaToggle name="fallbackToEmail" toggled={fallbackToEmail} onClick={handleFallbackToEmailChange}/>
                            </Form.Group>
                        </>
                        }
                            {
                                loading && <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                        </div>
                        </SkeletonTheme>
                    }
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}